/**
 * Thickness Upcharges by Product Code
 * Format: THICKNESS_UPCHARGES[productCode][thicknessCode][sizeCode] = dollarAmount
 * Example: THICKNESS_UPCHARGES.BL31000.FCO_38["06"] → 15.95
 */

export const THICKNESS_UPCHARGES = {
  BL31000: {
    FCO_14: {
      "02": 0,
      "03": 0,
      "04": 0,
      "05": 0,
      "06": 0,
      "07": 0,
      "08": 0,
      "09": 0,
      10: 0,
      11: 0,
      12: 0,
      13: 0,
      14: 0,
      15: 0,
      16: 0,
      17: 0,
      18: 0,
      19: 0,
      20: 0,
      21: 0,
      22: 0,
      23: 0,
      24: 0,
    },
    FCO_38: {
      "02": 14.0,
      "03": 14.0,
      "04": 19.0,
      "05": 22.0,
      "06": 117.0,
      "07": 24.0,
      "08": 26.04,
      "09": 32.06,
      10: 33.0,
      11: 33.0,
      12: 39.0,
      13: 40.0,
      14: 45.0,
      15: 53.0,
      16: 65.0,
      17: 68.0,
      18: 83.0,
      19: 85.0,
      20: 94.0,
      21: 85.0,
      22: 89.0,
      23: 91.0,
      24: 56.0,
    },
    FCO_12: {
      "02": 26.0,
      "03": 30.0,
      "04": 30.0,
      "05": 33.0,
      "06": 32.0,
      "07": 31.0,
      "08": 33.0,
      "09": 41.0,
      10: 41.0,
      11: 50.0,
      12: 59.0,
      13: 71.0,
      14: 81.0,
      15: 88.0,
      16: 102.0,
      17: 119.0,
      18: 141.0,
      19: 149.0,
      20: 170.0,
      21: 173.0,
      22: 186.0,
      23: 194.0,
      24: 171.0,
    },
    FCO_34: {
      "02": 33.0,
      "03": 36.0,
      "04": 34.0,
      "05": 39.0,
      "06": 45.0,
      "07": 55.0,
      "08": 70.0,
      "09": 85.0,
      10: 100.0,
      11: 116.0,
      12: 140.0,
      13: 162.0,
      14: 181.0,
      15: 203.0,
      16: 236.0,
      17: 269.0,
      18: 308.0,
      19: 336.01,
      20: 372.0,
      21: 394.0,
      22: 426.0,
      23: 455.0,
      24: 455.0,
    },
    FCO_10: {
      "02": 42.0,
      "03": 42.0,
      "04": 43.0,
      "05": 52.0,
      "06": 56.0,
      "07": 68.0,
      "08": 90.0,
      "09": 117.0,
      10: 147.0,
      11: 176.0,
      12: 208.0,
      13: 242.0,
      14: 277.0,
      15: 307.0,
      16: 353.0,
      17: 396.0,
      18: 447.0,
      19: 500.0,
      20: 566.05,
      21: 616.0,
      22: 677.0,
      23: 740.0,
      24: 777.01,
    },
  },

  BL32000: {
    FCO_14: {
      "02": 0,
      "03": 0,
      "04": 0,
      "05": 0,
      "06": 0,
      "07": 0,
      "08": 0,
      "09": 0,
      10: 0,
      11: 0,
      12: 0,
      13: 0,
      14: 0,
      15: 0,
      16: 0,
      17: 0,
      18: 0,
      19: 0,
      20: 0,
      21: 0,
      22: 0,
      23: 0,
      24: 0,
    },
    FCO_38: {
      "02": 15.0,
      "03": 17.0,
      "04": 20.0,
      "05": 26.0,
      "06": 36.0,
      "07": 41.0,
      "08": 51.0,
      "09": 63.0,
      10: 79.0,
      11: 86.0,
      12: 96.0,
      13: 106.0,
      14: 118.0,
      15: 133.0,
      16: 149.0,
      17: 167.0,
      18: 184.0,
      19: 206.0,
      20: 229.0,
      21: 247.0,
      22: 262.0,
      23: 278.0,
      24: 290.0,
    },
    FCO_12: {
      "02": 19.0,
      "03": 18.0,
      "04": 46.0,
      "05": 54.0,
      "06": 66.0,
      "07": 72.0,
      "08": 93.0,
      "09": 117.0,
      10: 151.09,
      11: 181.0,
      12: 219.0,
      13: 257.0,
      14: 295.0,
      15: 339.0,
      16: 387.0,
      17: 442.0,
      18: 497.0,
      19: 553.0,
      20: 649.0,
      21: 716.0,
      22: 778.0,
      23: 841.0,
      24: 910.0,
    },
  },

  BL33000: {
    FCO_14: {
      "02": 0,
      "03": 0,
      "04": 0,
      "05": 0,
      "06": 0,
      "07": 0,
      "08": 0,
      "09": 0,
      10: 0,
      11: 0,
      12: 0,
      13: 0,
      14: 0,
      15: 0,
      16: 0,
      17: 0,
      18: 0,
      19: 0,
      20: 0,
      21: 0,
      22: 0,
      23: 0,
      24: 0,
    },
    FCO_38: {
      "02": 15.0,
      "03": 17.0,
      "04": 20.0,
      "05": 26.0,
      "06": 36.0,
      "07": 41.0,
      "08": 51.0,
      "09": 63.0,
      10: 79.0,
      11: 86.0,
      12: 96.0,
      13: 106.0,
      14: 118.0,
      15: 133.0,
      16: 149.0,
      17: 167.0,
      18: 184.0,
      19: 206.0,
      20: 229.0,
      21: 247.0,
      22: 262.0,
      23: 278.0,
      24: 290.0,
    },
    FCO_12: {
      "02": 19.0,
      "03": 18.0,
      "04": 46.0,
      "05": 54.0,
      "06": 66.0,
      "07": 72.0,
      "08": 93.0,
      "09": 117.0,
      10: 151.09,
      11: 181.0,
      12: 219.0,
      13: 257.0,
      14: 295.0,
      15: 339.0,
      16: 387.0,
      17: 442.0,
      18: 497.0,
      19: 553.0,
      20: 649.0,
      21: 716.0,
      22: 778.0,
      23: 841.0,
      24: 910.0,
    },
  },

  BL40100: {
    FCO_18: {
      "02": 0,
      "03": 0,
      "04": 0,
      "05": 0,
      "06": 0,
      "07": 0,
      "08": 0,
      "09": 0,
      10: 0,
      11: 0,
      12: 0,
      13: 0,
      14: 0,
      15: 0,
      16: 0,
      17: 0,
      18: 0,
      19: 0,
      20: 0,
      21: 0,
      22: 0,
      23: 0,
      24: 0,
    },
    FCO_14: {
      "02": 2.03,
      "03": 2.03,
      "04": 3.09,
      "05": 3.12,
      "06": 4.08,
      "07": 5.17,
      "08": 7.19,
      "09": 8.21,
      10: 9.26,
      11: 11.33,
      12: 11.3,
      13: 13.35,
      14: 15.53,
      15: 17.51,
      16: 19.56,
      17: 21.64,
      18: 23.72,
      19: 25.75,
      20: 25.78,
      21: 26.79,
      22: 33.98,
      23: 36.02,
      24: 38.16,
    },
    FCO_38: {
      "02": 10.27,
      "03": 10.27,
      "04": 10.3,
      "05": 11.36,
      "06": 14.38,
      "07": 14.44,
      "08": 17.49,
      "09": 18.51,
      10: 19.56,
      11: 21.63,
      12: 23.66,
      13: 27.77,
      14: 32.01,
      15: 35.02,
      16: 40.16,
      17: 41.21,
      18: 46.38,
      19: 49.44,
      20: 55.65,
      21: 60.78,
      22: 63.85,
      23: 71.04,
      24: 78.33,
    },
    FCO_12: {
      "02": 12.33,
      "03": 12.33,
      "04": 15.45,
      "05": 16.51,
      "06": 19.52,
      "07": 20.62,
      "08": 24.7,
      "09": 27.78,
      10: 28.83,
      11: 32.96,
      12: 37.05,
      13: 45.28,
      14: 49.52,
      15: 48.41,
      16: 55.61,
      17: 59.75,
      18: 64.92,
      19: 74.16,
      20: 80.37,
      21: 85.5,
      22: 92.69,
      23: 101.94,
      24: 110.26,
    },
  },

  BL40200: {
    FCO_18: {
      "02": 0,
      "03": 0,
      "04": 0,
      "05": 0,
      "06": 0,
      "07": 0,
      "08": 0,
      "09": 0,
      10: 0,
      11: 0,
      12: 0,
      13: 0,
      14: 0,
      15: 0,
      16: 0,
      17: 0,
      18: 0,
      19: 0,
      20: 0,
      21: 0,
      22: 0,
      23: 0,
      24: 0,
    },
    FCO_14: {
      "02": 0,
      "03": 1.73,
      "04": 3.53,
      "05": 2.58,
      "06": 3.49,
      "07": 4.34,
      "08": 5.29,
      "09": 6.12,
      10: 7.02,
      11: 7.93,
      12: 7.83,
      13: 8.71,
      14: 11.42,
      15: 12.27,
      16: 13.1,
      17: 15.78,
      18: 16.54,
      19: 18.37,
      20: 17.56,
      21: 17.51,
      22: 22.72,
      23: 25.4,
      24: 26.31,
    },
    FCO_38: {
      "02": 0,
      "03": 7.86,
      "04": 8.79,
      "05": 7.84,
      "06": 9.61,
      "07": 10.47,
      "08": 12.3,
      "09": 14.0,
      10: 14.9,
      11: 16.68,
      12: 19.21,
      13: 21.84,
      14: 24.55,
      15: 27.16,
      16: 29.74,
      17: 33.29,
      18: 36.73,
      19: 41.14,
      20: 43.82,
      21: 47.28,
      22: 51.61,
      23: 56.92,
      24: 61.33,
    },
    FCO_12: {
      "02": 0,
      "03": 9.61,
      "04": 10.54,
      "05": 11.34,
      "06": 13.12,
      "07": 14.84,
      "08": 17.55,
      "09": 19.25,
      10: 21.91,
      11: 23.69,
      12: 27.09,
      13: 31.47,
      14: 35.06,
      15: 35.91,
      16: 39.37,
      17: 42.93,
      18: 47.23,
      19: 52.52,
      20: 56.95,
      21: 61.29,
      22: 67.37,
      23: 73.56,
      24: 79.72,
    },
  },

  PFL100: {
    one_half_inch: {
      "04": 0,
      "05": 0,
      "06": 0,
      "07": 0,
      "08": 0,
      "09": 0,
      10: 0,
      11: 0,
      12: 0,
      13: 0,
      14: 0,
      15: 0,
      16: 0,
      17: 0,
      18: 0,
      19: 0,
      20: 0,
      21: 0,
      22: 0,
      23: 0,
      24: 0,
    },
    three_quarter_inch: {
      "04": 3.1,
      "05": 5.15,
      "06": 5.15,
      "07": 6.2,
      "08": 9.25,
      "09": 9.25,
      10: 10.25,
      11: 11.25,
      12: 13.25,
      13: 15.25,
      14: 15.25,
      15: 12.25,
      16: 14.25,
      17: 14.25,
      18: 16.25,
      19: 18.25,
      20: 20.25,
      21: 22.25,
      22: 24.25,
      23: 25.0,
      24: 28.5,
    },
    one_inch: {
      "04": 7.2,
      "05": 9.25,
      "06": 11.25,
      "07": 13.25,
      "08": 17.5,
      "09": 19.5,
      10: 21.5,
      11: 24.5,
      12: 29.5,
      13: 32.5,
      14: 36.5,
      15: 34.5,
      16: 39.5,
      17: 41.5,
      18: 46.0,
      19: 51.5,
      20: 56.5,
      21: 61.5,
      22: 67.5,
      23: 72.5,
      24: 79.5,
    },
    one_and_half_inch: {
      "04": 100.0,
      "05": 100.0,
      "06": 15.25,
      "07": 28.5,
      "08": 24.75,
      "09": 16.75,
      10: 30.75,
      11: 34.75,
      12: 40.75,
      13: 46.75,
      14: 66.75,
      15: 51.75,
      16: 57.75,
      17: 62.75,
      18: 68.75,
      19: 76.75,
      20: 84.75,
      21: 92.75,
      22: 100.0,
      23: 108.75,
      24: 118.55,
    },
    two_inch: {
      "04": 100.0,
      "05": 100.0,
      "06": 20.6,
      "07": 24.5,
      "08": 31.0,
      "09": 35.0,
      10: 40.0,
      11: 45.0,
      12: 53.0,
      13: 60.0,
      14: 67.0,
      15: 69.0,
      16: 76.0,
      17: 84.0,
      18: 92.0,
      19: 102.0,
      20: 112.5,
      21: 122.5,
      22: 133.5,
      23: 145.0,
      24: 157.5,
    },
  },

  BL70100: {
    FCO_14: {
      "03": 0,
      "04": 0,
      "05": 0,
      "06": 0,
      "07": 0,
      "08": 0,
      "09": 0,
      10: 0,
      11: 0,
      12: 0,
      13: 0,
      14: 0,
      15: 0,
      16: 0,
      17: 0,
      18: 0,
      19: 0,
      20: 0,
      21: 0,
      22: 0,
      23: 0,
      24: 0,
    },
    FCO_38: {
      "03": 5.15,
      "04": 5.15,
      "05": 5.15,
      "06": 7.2,
      "07": 6.2,
      "08": 6.2,
      "09": 7.3,
      10: 7.3,
      11: 7.3,
      12: 8.25,
      13: 9.25,
      14: 11.25,
      15: 11.25,
      16: 14.5,
      17: 13.5,
      18: 15.5,
      19: 16.5,
      20: 20.5,
      21: 23.5,
      22: 20.5,
      23: 23.5,
      24: 26.75,
    },
    FCO_12: {
      "03": 6.2,
      "04": 7.2,
      "05": 8.25,
      "06": 9.25,
      "07": 9.25,
      "08": 10.25,
      "09": 12.25,
      10: 11.25,
      11: 13.25,
      12: 16.5,
      13: 19.5,
      14: 20.5,
      15: 18.5,
      16: 22.5,
      17: 23.5,
      18: 25.75,
      19: 29.75,
      20: 34.0,
      21: 36.0,
      22: 36.0,
      23: 40.0,
      24: 44.25,
    },
    FCO_34: {
      "03": 10.25,
      "04": 12.25,
      "05": 12.25,
      "06": 15.5,
      "07": 16.5,
      "08": 18.5,
      "09": 21.5,
      10: 21.5,
      11: 25.75,
      12: 29.75,
      13: 34.0,
      14: 36.0,
      15: 37.0,
      16: 40.0,
      17: 43.25,
      18: 48.5,
      19: 53.5,
      20: 55.5,
      21: 66.0,
      22: 67.0,
      23: 74.0,
      24: 80.0,
    },
    FCO_10: {
      "03": 16.5,
      "04": 19.5,
      "05": 20.0,
      "06": 25.0,
      "07": 28.75,
      "08": 34.0,
      "09": 37.0,
      10: 41.25,
      11: 44.25,
      12: 52.5,
      13: 58.75,
      14: 69.0,
      15: 66.0,
      16: 74.0,
      17: 79.0,
      18: 87.5,
      19: 96.75,
      20: 107.0,
      21: 116.0,
      22: 125.0,
      23: 136.0,
      24: 148.0,
    },
    FCO_112: {
      "03": 35.0,
      "04": 41.25,
      "05": 44.25,
      "06": 52.5,
      "07": 60.0,
      "08": 70.0,
      "09": 80.0,
      10: 89.5,
      11: 100.0,
      12: 115.0,
      13: 130.0,
      14: 145.0,
      15: 151.0,
      16: 167.0,
      17: 182.0,
      18: 200.0,
      19: 220.0,
      20: 242.0,
      21: 263.0,
      22: 283.0,
      23: 309.0,
      24: 334.0,
    },
  },
};

/**
 * Get thickness upcharge in dollars
 * @param {string} productCode - e.g. "BL31000"
 * @param {string} thickness - e.g. "FCO_38"
 * @param {string} size - e.g. "06"
 * @returns {number} Dollar amount to add
 */
export const getThicknessUpcharge = (productCode, thickness, size) => {
  const upcharge = THICKNESS_UPCHARGES[productCode]?.[thickness]?.[size];
  return upcharge ?? 0;
};
